import { Navigate, useSearchParams } from 'react-router-dom'

function buildSuffix(searchParams: URLSearchParams): string {
  const suffix = searchParams.toString()
  return suffix ? `?${suffix}` : ''
}

export function LegacyProfileHtmlRedirect() {
  const [searchParams] = useSearchParams()
  const hasOauthPayload = searchParams.has('code') || searchParams.has('state') || searchParams.has('error')
  if (hasOauthPayload) {
    return <Navigate to={`/auth/callback${buildSuffix(searchParams)}`} replace />
  }
  return <Navigate to={`/profile${buildSuffix(searchParams)}`} replace />
}

export function LegacyCreateTournamentAliasRedirect() {
  const [searchParams] = useSearchParams()
  const orgId = String(searchParams.get('orgId') || '').trim()
  const tournamentId = String(searchParams.get('tournamentId') || '').trim()
  const q = new URLSearchParams()
  if (orgId) q.set('orgId', orgId)
  const suffix = buildSuffix(q)

  if (tournamentId) {
    return <Navigate to={`/tournaments/${encodeURIComponent(tournamentId)}/edit${suffix}`} replace />
  }
  return <Navigate to={`/tournaments/new${suffix}`} replace />
}

export function LegacyTournamentsHtmlRedirect() {
  const [searchParams] = useSearchParams()
  return <Navigate to={`/workspace${buildSuffix(searchParams)}`} replace />
}
